import ReactDOM from 'react-dom/client';

import settings from '@src/conf';
import { CATEGORIES, createRegistry } from '@src/corelib/consent';
import { consoleUtils, storageUtils, versionUtils } from '@src/corelib/utils';

import App from './App';
import { clarityPlugin, sentryPlugin } from './plugins';
import router from './router';


function init() {
  return new Promise((resolve, reject) => {
    const currentVersion = versionUtils.getPackageVersion();
    const previousVersion = versionUtils.getAppVersion();
    if (previousVersion !== currentVersion) {
      Promise.all([storageUtils.clearLocalStorage()])
        .then(() => {
          versionUtils.setAppVersion(currentVersion);
          resolve({ version: currentVersion });
        })
        .catch((error) => {
          reject(error);
        });
    }
    else {
      resolve({ version: currentVersion });
    }
  });
}

init()
  .then(() => {
    if (import.meta.env.MODE === 'production') {
      consoleUtils.userWarning();
    }

    // Init settings
    settings.init();

    // Sentry error + performance capture is strictly necessary (site
    // reliability) and starts immediately so bootstrap failures are captured.
    // Session replay is NOT started here — the consent registry adds it on
    // 'analytics' grant.
    sentryPlugin.init({ context: { router } });

    // Nothing else tracking-related runs until the visitor consents. The
    // registry initialises already-granted trackers now and subscribes for
    // grants made later in this page load.
    createRegistry({
      trackers: [
        { id: 'clarity', category: CATEGORIES.MARKETING, init: clarityPlugin.init },
        { id: 'sentryReplay', category: CATEGORIES.ANALYTICS, init: sentryPlugin.enableReplay },
      ],
    }).start();

    // Render the app
    const rootElement = document.getElementById('root');
    const root = ReactDOM.createRoot(rootElement);
    root.render(<App />);
  })
  .catch((error) => {
    console.error('App Init Error: ', error);
  });
